/* The footer's copy button, and nothing else.

   The welcome screen already had one, but its handler is scoped to the
   popup's own element (nx-welcome.js), which is correct there — a
   document-wide listener living inside a modal's script is the kind of
   coupling that breaks the day the modal is deleted. So the footer owns
   its own, at the same cost.

   ⚠ `navigator.clipboard` is undefined on an insecure origin. The button
   says so rather than silently doing nothing: a control that looks like
   it worked and did not is worse than one that admits it. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nx-footer-copy]');
    if (!btn) return;
    var wrap = btn.closest('.nxf__code');
    var code = wrap && wrap.querySelector('[data-nx-footer-code]');
    if (!code) return;
    var text = code.textContent.trim();
    if (!navigator.clipboard) { btn.textContent = 'Select it'; return; }
    navigator.clipboard.writeText(text).then(
      function () { btn.textContent = 'Copied'; },
      function () { btn.textContent = 'Select it'; }
    );
  });
})();
